import ClearIcon from "@mui/icons-material/Clear";
import React, { useCallback } from "react";
import { useAppDispatch } from "hooks/hooks";
import { debounce } from "lodash";
import {
  deleteHistoricValueForResource,
  updateHistoricValues
} from "../details.slice";
import {
  IAddHistoricValueToResourceRequestParams
} from "Dashboard/scenes/Resources/domain/IAddHistoricValueToResourceRequestParams";
import { resourcesServices } from "Dashboard/scenes/Resources/services/resource.service";
import CurrencyInput from "react-currency-input-field";

interface IProps {
  resourceId: number;
  year: string;
  value: number;
}

export const HistoricValueRow = ({ resourceId, year, value }: IProps) => {
  const dispatch = useAppDispatch();

  const delayedHistoricValueUpdate = useCallback(
    debounce(async (data: IAddHistoricValueToResourceRequestParams) => {
      try {
        const { year, ...otherProps } = data
        const yearToNumber = year
        const dataToUpdate = { year: yearToNumber, ...otherProps }
        const resourceDetails = await resourcesServices.addOrEditHistoricValueToResource(dataToUpdate);
        dispatch(updateHistoricValues(resourceDetails));
      } catch (err) {
        console.log(err);
      }
    }, 1000),
    []
  );

  const onValueChanged = (value: number) => {
    if (value) {
      const newHistoricValue: any = { resourceId, year, value };
      dispatch(updateHistoricValues(newHistoricValue));
      delayedHistoricValueUpdate(newHistoricValue);
    }
  };

  const deleteHistoricValue = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    try {
      const historicValue = await dispatch(
        deleteHistoricValueForResource({
          resourceId,
          year: parseInt(year)
        })
      ).unwrap();
      if (historicValue) {
        dispatch(updateHistoricValues(historicValue));
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <article key={year} className="details-article">
      <span className="details-cell">{year}</span>
      <CurrencyInput
        id="input-example"
        className="details-cell"
        name="value"
        suffix=" rsd"
        value={value}
        decimalsLimit={2}
        decimalSeparator=","
        groupSeparator="."
        onValueChange={(value: string | undefined, name) => {
          const amount: number = value !== undefined ? Number(value) : 0;
          onValueChanged(amount)
        }}
      />
      <button
        className="historic-value-button"
        onClick={deleteHistoricValue}
      >
        <ClearIcon fontSize="small" />
      </button>
    </article>
  );
};
